const a = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ', 'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen ']
const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety']

const c = ['Zero ', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ', 'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen ']
const regex = /^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/

const getLT20 = (n) => a[Number(n)]
const anotherGetLT20 = (n) => c[Number(n)]
const get20Plus = (n) => b[n[0]] + ' ' + a[n[1]]

const getNumberWords = (input) => {
  const num = Number(Math.floor(+input))
  if (isNaN(num)) return ''
  if (num === 0) return 'Zero '

  const numStr = num.toString()
  if (numStr.length > 9) {
    // message.error('')
  }

  const [, n1, n2, n3, n4, n5] = ('000000000' + numStr).substr(-9).match(regex) // left pad zeros

  let str = ''
  str += +n1 !== 0 ? (getLT20(n1) || get20Plus(n1)) + 'Crore ' : ''
  str += +n2 !== 0 ? (getLT20(n2) || get20Plus(n2)) + 'Lakh ' : ''
  str += +n3 !== 0 ? (getLT20(n3) || get20Plus(n3)) + 'Thousand ' : ''
  str += +n4 !== 0 ? getLT20(n4) + 'Hundred ' : ''
  str += +n5 !== 0 && str !== '' ? 'and ' : ''
  str += +n5 !== 0 ? (getLT20(n5) || get20Plus(n5)) : ''

  return str.trim()
}

const arr = x => Array.from(x);
const num = x => Number(x) || 0;
const str = x => String(x);
const isEmpty = xs => xs.length === 0;
const take = n => xs => xs.slice(0, n);
const drop = n => xs => xs.slice(n);
const reverse = xs => xs.slice(0).reverse();
const comp = f => g => x => f(g(x));
const not = x => !x;
const chunk = n => xs =>
  isEmpty(xs) ? [] : [take(n)(xs), ...chunk(n)(drop(n)(xs))];

// numToWords :: (Number a, String a) => a -> String
const numToWords = (n) => {

  const a = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];

  const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  const g = ['', 'Thousand', 'Million', 'Billion', 'Trillion', 'Quadrillion', 'Quintillion', 'Sextillion', 'Septillion', 'Octillion', 'Nonillion'];

  let makeGroup = ([ones, tens, huns]) => {
    return [
      num(huns) === 0 ? '' : a[huns] + ' Hundred ',
      num(ones) === 0 ? b[tens] : b[tens] && b[tens] + '-' || '',
      a[tens + ones] || a[ones]
    ].join('');
  };

  let thousand = (group, i) => group === '' ? group : `${group} ${g[i]}`;

  if (typeof n === 'number')
    return numToWords(String(n));
  else if (n === '0')
    return 'zero';
  else
    return comp(chunk(3))(reverse)(arr(n))
      .map(makeGroup)
      .map(thousand)
      .filter(comp(not)(isEmpty))
      .reverse()
      .join(' ');
};

const convertPointToString = (input) => {
  const fractional = [...input];
  let fractionalString = ' Point ';
  fractional?.forEach(eachInt => {
    fractionalString = fractionalString + anotherGetLT20(eachInt)
  });
  return fractionalString;
}
export const convertNumTOWords = (input, currency?) => {
  const decimalNumber = input.toString().split('.');
  const wordsString = numToWords(decimalNumber[0]);
  return currency + ' ' + wordsString + (decimalNumber.length > 1 ? convertPointToString(decimalNumber[1]) : '') + ' Only';
}
